export default __webpack_public_path__ + "static/media/klimator-logo.0838c05a.svg";